import React, { useEffect, useState } from "react"

import Layout from "../../components/shared/layout"
import useHeroImages from "../../components/careers/useHeroImages"

import Hero from "../../components/shared/hero"
import {
  HeroOverlay,
  HeroContent,
  HeroLink,
  Title,
} from "../../components/careers/hero.style"
import CultureSection from "../../components/careers/culture"
import ProblemSolving from "../../components/careers/problem-solving"
import EmployeeTestimonials from "../../components/careers/employee-testimonials"
import Footer from "../../components/shared/footer"
import SEO from "../../components/shared/seo"
import Values from "../../components/careers/values"
import OpenPositions from "../../components/careers/open-positions"
import PerksBenefits from "../../components/careers/perks-benefits"
import externalLinks from "../../external-links"

const ENDPOINT = externalLinks.jobPostings
  

export default function CareersPage({ location }) {
  const [jobs, setJobs] = useState([])

  useEffect(() => {
    fetch(ENDPOINT)
      .then(res => res.json())
      .then(data => {
        //apparently jazzhr returns an object instead of array if there's only 1 posting
        if (Array.isArray(data)) {
          setJobs(data)
        } else {
          setJobs([data])
        }
      })
  }, [])

  const images = useHeroImages()
  return (
    <Layout location={location} contactLightbox>
      <SEO
        title="Careers"
        description="Join Mappedin today and help us build the platform for spaces!"
      />
      <Hero overlayStyle={HeroOverlay} sizes={images}>
        <HeroContent>
          <Title>
            Join our team today to help us build the platform for spaces
          </Title>
          {jobs.length > 0 && (
            <HeroLink to="open-positions" smooth={true} duration={1000}>
              See Open Positions
            </HeroLink>
          )}
        </HeroContent>
      </Hero>
      <CultureSection />
      <ProblemSolving />
      <Values />
      <PerksBenefits />
      <EmployeeTestimonials />
      <OpenPositions jobs={jobs} />
      <Footer />
    </Layout>
  )
}
